import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { HttpTransportType, HubConnectionBuilder } from '@microsoft/signalr';
import { ApplicationShared, getAppNameFromAppString, getContextFromAppName, useAuth, useProfile } from '@brg/auth';
import useCommonProps from './useCommonProps';
import { API } from '@brg/api';
import useLocalization from './useLocalization';
var getUrl = function () {
    switch (process.env.REACT_APP_API_CONNECTION_MODE) {
        case 'production':
            return 'https://notifications.mediiia.ru';
        case 'staging':
            return 'https://notifications.burgstg.ru';
        default:
            return 'https://notifications.burgdev.ru';
    }
};
export var PostSocketContext = createContext({
    connection: undefined,
    connectionId: undefined
});
export var PostSocketProvider = function (_a) {
    var children = _a.children;
    var token = useAuth().token;
    var connectionRef = useRef();
    var profile = useProfile();
    var appName = useCommonProps().appName;
    var serviceId = getAppNameFromAppString(appName || '');
    var clientId = getContextFromAppName(ApplicationShared.application);
    var _b = useState(), connectionId = _b[0], setConnectionId = _b[1];
    var _c = useState(), currentConnection = _c[0], setCurrentConnection = _c[1];
    var language = useLocalization().language;
    var currentStateRef = useRef(null);
    var currentLangRef = useRef(null);
    useEffect(function () {
        currentLangRef.current = language;
    }, [language]);
    useEffect(function () {
        var connection = new HubConnectionBuilder()
            .withUrl("".concat(getUrl(), "/WebSocketProvider"), {
            accessTokenFactory: function () { return token; },
            transport: HttpTransportType.WebSockets
        })
            .withAutomaticReconnect()
            .build();
        connectionRef.current = connection;
        if (profile) {
            connection
                .start()
                .then(function () {
                connection
                    .invoke('GetConnectionId', serviceId, clientId, profile.accountId)
                    .then(function (connectionId) {
                    setConnectionId(connectionId);
                });
                // onStart();
            })
                .catch(console.error);
            setCurrentConnection(connection);
            connection.on('Receive', function (message) {
                var _a, _b, _c, _d, _e;
                var messageObj = API.toLang(JSON.parse(message), ((_a = currentLangRef.current) === null || _a === void 0 ? void 0 : _a.language) || 'en');
                var info = (_b = messageObj === null || messageObj === void 0 ? void 0 : messageObj.actions) === null || _b === void 0 ? void 0 : _b[0];
                var postId = ((_c = currentStateRef.current) === null || _c === void 0 ? void 0 : _c.postId) || '';
                var timer = ((_d = currentStateRef.current) === null || _d === void 0 ? void 0 : _d.timer) || null;
                var action = ((_e = currentStateRef.current) === null || _e === void 0 ? void 0 : _e.action) || null;
                if ((info === null || info === void 0 ? void 0 : info.type) === 'uploadedFile' && (info === null || info === void 0 ? void 0 : info.entityId) === postId && postId !== undefined) {
                    if (timer)
                        clearTimeout(timer);
                    if (action)
                        action();
                    currentStateRef.current = null;
                }
            });
        }
        return function () {
            connection.stop();
            setCurrentConnection(null);
        };
    }, [profile]);
    return (React.createElement(PostSocketContext.Provider, { value: {
            connection: currentConnection,
            connectionId: connectionId,
            currentState: currentStateRef.current,
            setCurrentState: function (state) { return currentStateRef.current = state; }
        } }, children));
};
export function usePostSocketContext() {
    return useContext(PostSocketContext);
}
//# sourceMappingURL=usePostSocketContext.js.mapimport React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { HttpTransportType, HubConnectionBuilder } from '@microsoft/signalr';
import { ApplicationShared, getAppNameFromAppString, getContextFromAppName, useAuth, useProfile } from '@brg/auth';
import useCommonProps from './useCommonProps';
import { API } from '@brg/api';
import useLocalization from './useLocalization';
var getUrl = function () {
    switch (process.env.REACT_APP_API_CONNECTION_MODE) {
        case 'production':
            return 'https://notifications.mediiia.ru';
        case 'staging':
            return 'https://notifications.burgstg.ru';
        default:
            return 'https://notifications.burgdev.ru';
    }
};
export var PostSocketContext = createContext({
    connection: undefined,
    connectionId: undefined
});
export var PostSocketProvider = function (_a) {
    var children = _a.children;
    var token = useAuth().token;
    var connectionRef = useRef();
    var profile = useProfile();
    var appName = useCommonProps().appName;
    var serviceId = getAppNameFromAppString(appName || '');
    var clientId = getContextFromAppName(ApplicationShared.application);
    var _b = useState(), connectionId = _b[0], setConnectionId = _b[1];
    var _c = useState(), currentConnection = _c[0], setCurrentConnection = _c[1];
    var language = useLocalization().language;
    var currentStateRef = useRef(null);
    var currentLangRef = useRef(null);
    useEffect(function () {
        currentLangRef.current = language;
    }, [language]);
    useEffect(function () {
        var connection = new HubConnectionBuilder()
            .withUrl("".concat(getUrl(), "/WebSocketProvider"), {
            accessTokenFactory: function () { return token; },
            transport: HttpTransportType.WebSockets
        })
            .withAutomaticReconnect()
            .build();
        connectionRef.current = connection;
        if (profile) {
            connection
                .start()
                .then(function () {
                connection
                    .invoke('GetConnectionId', serviceId, clientId, profile.accountId)
                    .then(function (connectionId) {
                    setConnectionId(connectionId);
                });
                // onStart();
            })
                .catch(console.error);
            setCurrentConnection(connection);
            connection.on('Receive', function (message) {
                var _a, _b, _c, _d, _e;
                var messageObj = API.toLang(JSON.parse(message), ((_a = currentLangRef.current) === null || _a === void 0 ? void 0 : _a.language) || 'en');
                var info = (_b = messageObj === null || messageObj === void 0 ? void 0 : messageObj.actions) === null || _b === void 0 ? void 0 : _b[0];
                var postId = ((_c = currentStateRef.current) === null || _c === void 0 ? void 0 : _c.postId) || '';
                var timer = ((_d = currentStateRef.current) === null || _d === void 0 ? void 0 : _d.timer) || null;
                var action = ((_e = currentStateRef.current) === null || _e === void 0 ? void 0 : _e.action) || null;
                if ((info === null || info === void 0 ? void 0 : info.type) === 'uploadedFile' && (info === null || info === void 0 ? void 0 : info.entityId) === postId && postId !== undefined) {
                    if (timer)
                        clearTimeout(timer);
                    if (action)
                        action();
                    currentStateRef.current = null;
                }
            });
        }
        return function () {
            connection.stop();
            setCurrentConnection(null);
        };
    }, [profile]);
    return (React.createElement(PostSocketContext.Provider, { value: {
            connection: currentConnection,
            connectionId: connectionId,
            currentState: currentStateRef.current,
            setCurrentState: function (state) { return currentStateRef.current = state; }
        } }, children));
};
export function usePostSocketContext() {
    return useContext(PostSocketContext);
}
//# sourceMappingURL=usePostSocketContext.js.map